import { queryNamespace } from '@libs/shared/frontend/helpers/query-namespace.helper';
import { queryOptions } from '@tanstack/react-query';

import { client, HttpException } from '@/libs/openapi';
import { fromApiUserFieldAdapter } from '@/resources/user/user.field-adapter';
import { Resource } from '@/types/resource.type';

export const organizationQueries = queryNamespace(Resource.organization, {
  me: queryOptions({
    queryKey: [],
    queryFn: ({ signal }) => client
      .GET('/customer/api/tcd/organizations', { signal })
      .then(({ data, error, response }) => {
        if (error) {
          throw new HttpException({
            message: Array.isArray(error.message) ? error.message[0] : error.message,
            response,
            isGlobal: true,
          });
        }

        return data;
      }),
    staleTime: Infinity,
    select: (data) => ({
      original: data,
      meta: {
        accountManagerFullName: data.accountManager && fromApiUserFieldAdapter.getFullName(data.accountManager),
        coverageMemberFullName: data.coverageMember && fromApiUserFieldAdapter.getFullName(data.coverageMember),
        coverageLeaveUntilFormatted: data.coverageMemberEndDate && fromApiUserFieldAdapter.getCoveredUntil(data.coverageMemberEndDate),
      },
    }),
  }),
});
